export const dateRangePickerMonthsClasses = {
  selected: 'date-month--selected',
}
